/** @jsx onetext.jsx.element */

import type { OneText } from '../../../global';

// eslint-disable-next-line no-restricted-syntax
import { BottomGraphicDesktop, BottomGraphicMobile, UpperLeftGraphic, UpperRightGraphic } from '../images';

declare let onetext : OneText;

const { clsx } = onetext.jsx;

export const BrandBackgroundDefault = () : JSX.Element => (
    <div className={ 'absolute inset-0' }>
        <img
            className={ 'absolute top-[15px] left-[15px] w-[110px]' }
            src={ UpperLeftGraphic } />
        <img
            className={ 'absolute top-[15px] right-[15px] w-[85px]' }
            src={ UpperRightGraphic } />
        <div
            className={
                clsx(
                    'hidden md:flex',
                    'absolute bottom-0 left-0 right-0',
                    'w-full h-[44%]',
                    'bg-center bg-cover bg-no-repeat'
                )
            }
            style={ { backgroundImage: `url(${ BottomGraphicDesktop })` } }
        />
        <div
            className={
                clsx(
                    'md:hidden',
                    'absolute bottom-0 left-0 right-0',
                    'w-full h-1/4',
                    'bg-center bg-cover bg-no-repeat'
                )
            }
            style={ { backgroundImage: `url(${ BottomGraphicMobile })` } }
        />
    </div>
);
